// extracted by mini-css-extract-plugin
module.exports = {"container":"_4e5f713ae4--container--VWgf8","inner":"_4e5f713ae4--inner--hBpA_","title":"_4e5f713ae4--title--DSRj7","description":"_4e5f713ae4--description--TDqWD"};